export function makeToolsUrl(toolsServer) {
    const J = (j) => toolsServer + '/backoffice/proxy/behavior' + j;
    return {
        account: {
            postAccountInfoSave: J('/account/info/save'),
            getAccountInfoList: J('/account/infos'),
            getBehaviorAccountInfoSummary: J('/account/info/summary'),
        },
    };
}
